<template>
  <div style="height: 100%;">
    <a-card style="height: 100%;text-align: center;padding-top: 80px;">
      <div class="box">
        <img
          style="width: 845px;"
          src="https://static.51lss.com/o2o/themes/images/management/login/phoneReg.png"
          alt=""
        />
        <span>注册码：{{ ocdoe }}</span>
      </div>
    </a-card>
  </div>
</template>
<script>
export default {
  name: '',
  data() {
    return {}
  },
  computed: {
    ocdoe() {
      const data = this.$store.getters.getInfo(['ocode'])
      return data.ocode
    }
  },
  methods: {}
}
</script>
<style lang="less" scoped>
.box {
  position: relative;
  width: 845px;
  margin: 0 auto;
  span {
    position: absolute;
    left: 554px;
    top: 154px;
    font-size: 20px;
  }
}
</style>
